import React from 'react';
import { format } from 'date-fns';
import { TaskStatus } from '../../types';

interface FinalDateTaskDisplayProps {
  status: TaskStatus;
  finishDate: Date | null;
}

const FinalDateTaskDisplay: React.FC<FinalDateTaskDisplayProps> = ({
  status,
  finishDate,
}) => {
  const renderDate = () =>
    finishDate ? (
      <>
        <span>{format(finishDate, 'yyyy-MM-dd')}</span>
        <span>{format(finishDate, 'hh:mm:ss')}</span>
      </>
    ) : null;

  switch (status) {
    case 'inProgress':
      return <span>Loading</span>;
    case 'canceled':
      return <span>N/A</span>;
    case 'completed':
      return renderDate();
    case 'failed':
      return renderDate();
    default:
      return null;
  }
};

export default FinalDateTaskDisplay;
